import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "components/Layout";
import Reset from "components/Reset";
import { bindActionCreators } from "redux";
import { emailResetRequest } from "actions/auth";
import { connect } from "react-redux";
import { withRouter } from "next/router";
import { COLORS } from "utils/styles";
import PATHS from "utils/paths";
import { verifyRequest, SECURE_ACTIONS } from "utils/security";
import { landingStyles } from "components/Landing/landingStyles";

class ResetPage extends Component {
  constructor() {
    super();
    this.requestSuccess = this.requestSuccess.bind(this);
    this.reset = this.reset.bind(this);
  }

  static async getInitialProps({ req, query }) {
    const userAgent = req ? req.headers["user-agent"] : navigator.userAgent;

    return { userAgent, query };
  }

  requestSuccess() {
    const href = PATHS.LOGIN;
    const to = href;

    this.props.router.push(href, to, { shallow: false });
  }

  /**
   * Submit reset request for the user and validate via recpatcha
   * @param {Object} values - signup form values
   * @param {String} values.email - email of user
   * @param {String} values.password - password for account
   * @param {Function} resetCb
   */
  reset(values, resetCb) {
    const { emailResetRequest } = this.props.actions;

    verifyRequest({
      action: SECURE_ACTIONS.RESET,
      onSuccess: () => {
        emailResetRequest(values, resetCb);
      },
      onError: (err) => {
        resetCb(err);
      }
    });
  }

  render() {
    return (
      <Layout>
        {() => (
          <div
            className="h-100 w-100"
            style={{ backgroundColor: COLORS.whitesmoke }}
          >
            <Reset
              legend="Request a password reset link"
              submitCopy="Reset"
              request={this.reset}
              requestSuccess={this.requestSuccess}
            />
            <style jsx>{landingStyles}</style>
          </div>
        )}
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      emailResetRequest
    },
    dispatch
  )
});

ResetPage.propTypes = {
  router: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default withRouter(connect(null, mapDispatchToProps)(ResetPage));
